export enum Currency {
    "USD" = "usd",
    "PEN" = "pen"
}
